import { setUpEventListenersAndObserver } from "./eventHandlers";
import { createMovieGrid } from "./movieRenderer";

setUpEventListenersAndObserver();

createMovieGrid();
